import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "vueMain" }
const _hoisted_2 = { class: "ng-extend" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "neuroglancer-container" })
], -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "nge-auth-banner"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "nge-auth-banner-eye",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "nge-auth-banner-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-auth-banner-title" }, "Sauron has severed your link to the cave connectome tables"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-auth-banner-sub" }, "Your cell update was not saved.")
], -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.sessions.length > 0)
        ? (_openBlock(), _createBlock($setup["Tutorial"], { key: 0 }))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["ExtensionBar"])
    ]),
    _createVNode($setup["SplitMergeOverlay"]),
    _hoisted_3,
    _createVNode(_Transition, { name: "nge-auth-banner" }, {
      default: _withCtx(() => [
        ($setup.authExpired)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("button", {
                class: "nge-auth-banner-btn",
                onClick: $setup.hardReload
              }, "Refresh"),
              _createElementVNode("button", {
                class: "nge-auth-banner-close",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.authExpired = false)),
                title: "Dismiss"
              }, "×")
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}